import { render } from "./PlaceList.vue?vue&type=template&id=21639a9b&scoped=true&ts=true"
import script from "./PlaceList.vue?vue&type=script&lang=ts"
export * from "./PlaceList.vue?vue&type=script&lang=ts"

import "./PlaceList.vue?vue&type=style&index=0&id=21639a9b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21639a9b"]])

export default __exports__